'use strict';
/**
 * A directive to set up an alerts area
 */

angular.module('msOnboarding').directive('msSurvey', [function () {
  return {
    template: '<div data-ng-include src="vm.getTemplateUrl()"></div>',
    replace: true,
    restrict: 'AE',
    controllerAs: 'vm',
    scope: {},
    bindToController: {
      context: '@'
    },
    controller: 'SurveyCtrl'
  };
}]);